
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { moneyFormat } from "@/utils/util";
import FixedTable from "./fixedTable.vue";

export interface ITableColomns {
  key: string; // 列标识
  title: string; // 列名
  width: number; // 列宽
  align: string; // 列对齐 "right" "left" "center"
  sort: boolean; // 开启列排序 true false
  order: string; // asc 升序 desc 降序
  dataType: string; // 数据类型，percent 比例 | amount 金额 | discount 折扣 | proportion 占比
  fixed?: string; // left 固定左边
}

@Component({
  components: { FixedTable },
})
export default class CustomTable extends Vue {
  @Prop({ type: Number, default: 37 }) thH;
  @Prop({ type: String, default: "39px" }) rowH;
  @Prop({ type: Number }) scrollX;
  @Prop({ type: Boolean, default: true }) showReportIcon; // 是否显示报表按钮
  @Prop({ type: Boolean, default: true }) showEven; // 是否显示偶数行加深背景
  @Prop({ type: Boolean, default: true }) isInit; // 是否加载完成
  moneyFormat = moneyFormat;

  @Prop({
    default: () => {
      return [];
    },
  })
  columns!: Array<ITableColomns>; // 表格列配置
  @Prop({
    default: () => {
      return [];
    },
  })
  dataSource!: Array<Record<string, any>>; // 表格数据

  columnsFixed: Array<ITableColomns> = [];

  @Watch("isInit", { immediate: true })
  onParamsChange() {
    this.columnsFixed =
      this.columns?.filter((item) => item.fixed === "left") || [];
  }

  orderBy(item: ITableColomns) {
    // 先把其他的排序取消
    const otherColumn = this.columns.filter((i) => i.key !== item.key);
    otherColumn.forEach((item) => {
      item.order = "";
    });
    // 再设置当前排序
    if (item.order === "asc") {
      item.order = "desc";
    } else if (item.order === "desc") {
      item.order = "";
    } else {
      item.order = "asc";
    }
    this.$emit("orderByColumn", item);
  }
  toPercent(value: string) {
    // 避免出现 7.000000000000001情况
    return Math.round(Number(value) * 10000) / 100;
  }
  toDiscountClass(value: string) {
    // 90% 110% 原价
    const num = `${value}`.replace("%", "");
    if (Number(num) > 100) return "color-red";
    return "";
  }

  toAmount(value: string) {
    return parseFloat(Number(value).toFixed(2));
  }
}
